const accordions = {
	trigger: document.querySelectorAll( '.block-accordions__accordion-header' ),
	applyBtns: document.querySelectorAll( '.block-accordions__accordion-btn' ),
	formSubject: document.querySelector( 'input[name="your-subject"]' ),

	init() {
		if ( this.trigger.length > 0 ) {
			[ ...this.trigger ].forEach( ( accordion ) => {
				accordion.addEventListener( 'click', ( e ) =>
					this.toggleAccordion( e ),
				);
			} );
		}
		if ( this.applyBtns.length > 0 && this.formSubject ) {
			[ ...this.applyBtns ].forEach( ( btn ) => {
				btn.addEventListener( 'click', ( e ) => this.getApply( e ) );
			} );
		}
	},
	toggleAccordion( e ) {
		e.preventDefault();

		[ ...this.trigger ].forEach( ( accordion ) => {
			accordion.parentElement.classList.remove(
				'block-accordions__accordion--active',
			);
		} );

		e.currentTarget.parentElement.classList.add(
			'block-accordions__accordion--active',
		);
	},
	getApply( e ) {
		const dataTitle = e.target.dataset.title;
		this.formSubject.value = dataTitle;
	},
};

window.addEventListener( 'load', () => {
	accordions.init();
} );
